module.exports = __webpack_public_path__ + "img/dingsoEwm.ec0b6b46.png";